import React from 'react';
import { connect } from 'react-redux';

import About from '../../components/purchase-dashboard/about';
import { getCurrentPurchase } from '../../selectors/purchase-selector';

const AboutContainer = ({ merchant, product }) => {
  if (!product.link && !product.description) return null;

  return (
    <About
      description={product.description}
      link={product.link}
      merchantName={merchant.displayName}
      name={product.name}
    />
  );
};

const mapStateToProps = (state) => {
  const purchase = getCurrentPurchase(state);

  return {
    merchant: purchase.merchant,
    product: purchase.product,
  };
};

export default connect(mapStateToProps)(AboutContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-dashboard/about.js